import script from "./RegistrarChamada.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrarChamada.vue?vue&type=script&setup=true&lang=js"

import "./RegistrarChamada.vue?vue&type=style&index=0&id=e06d4b34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e06d4b34"]])

export default __exports__